export default {
    barmode: 'group',
    dragmode: 'select', // makes box select the default modebar tool
    hovermode: 'closest', // more obvious behavior (select point closest to where you hover/click) than default (select some point on axis)
    plot_bgcolor: '#2F3035',
    paper_bgcolor: '#2F3035',
    autosize: true,
    font: {
        color: 'white',
        family: "'Roboto', sans-serif",
        size: 10
    },
    margin: {
        t: 25,
        b: 100,
    },
    xaxis: {
        automargin: true,
        color: 'white', // grid lines are this color blended with background if you don't specify gridcolor
        tickangle: 45,
    },
    yaxis: {
        automargin: true,
        color: 'white', // grid lines are this color blended with background if you don't specify gridcolor
    },
    datarevision: 0
}